import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Goalskinekt() {
  return (
    <section className="goals-kinekt p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2 className="head-h2-kinekt">
              Project <span style={{ color: "#20A2BE" }}>Goals</span>
            </h2>

            <div className="goals-img">
              <StaticImage
                src="../../../images/case-studies/kinekt-new/goals-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={969}
                height={954}
              />
              <div className="goals-box box-1">
                <p>
                  Unify patient feedback from various channels (real-time
                  facility feedback, social media, phone inquiries, and
                  multimedia testimonials).
                </p>
              </div>
              <div className="goals-box box-2">
                <p>
                  Implement AI-driven sentiment analysis to extract valuable
                  insights.
                </p>
              </div>
              <div className="goals-box box-3">
                <p>
                  Enhance UI/UX for a seamless experience across web and mobile
                  platforms.
                </p>
              </div>
              <div className="goals-box box-4">
                <p>
                  Automate social content generation and engagement using AI.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Goalskinekt;
